/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

const tCloudflareImageFile = t.type({
  url: t.union([t.string, t.null]),
  small: t.type({ url: t.union([t.string, t.null]) }),
  medium: t.type({ url: t.union([t.string, t.null]) }),
  extraLarge: t.type({ url: t.union([t.string, t.null]) }),
});
export const tCloudflareImage = t.type({
  id: t.number,
  imageable_id: t.number,
  imageable_type: t.string,
  file: tCloudflareImageFile,
  file_processing: t.boolean,
  created_at: t.string,
  updated_at: t.string,
  position: t.union([t.number, t.null]),
  purpose: t.string,
});
